import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Record } from "immutable";
import { DateStringNumber } from "common/records";

export const eventResultReasonFromJSON = (json: Partial<IEventResultReasonData>): EventResultReasonRecord => {
  const eventResultReasonData: IEventResultReasonRecord = { ...(json as any) };

  if (json.created_at) {
    eventResultReasonData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    eventResultReasonData.updated_at = checkDate(json.updated_at);
  }

  return new EventResultReasonRecord(eventResultReasonData);
};

export interface IEventResultReasonData {
  id: number;
  org_id: number;
  ms_id: Nullable<string>;
  description: string;
  position: number;
  kind: string;
  events_result_id: Nullable<number>;
  url: string;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IEventResultReasonRecord {
  id: number;
  org_id: number;
  ms_id: string;
  description: string;
  position: number;
  kind: string;
  events_result_id: number;
  url: string;

  created_at: Date;
  updated_at: Date;
}

export const defaultEventResultReasonProps: IEventResultReasonRecord = {
  id: 0,
  org_id: 0,
  ms_id: "",
  description: "",
  position: 0,
  kind: "default",
  events_result_id: 0,
  url: "",

  created_at: new Date(),
  updated_at: new Date(),
};

export class EventResultReasonRecord
  extends Record(defaultEventResultReasonProps)
  implements IEventResultReasonRecord {}
